import { MindmapPaletteColors, MindmapPaletteThemeColor } from "./mindmap-theme";
import { MINDMAP_COLOR_BLACK_DIRTY, MINDMAP_COLOR_WHITE } from "./theme-constants";

export const DEFAULT_PALETTE_COLOR: MindmapPaletteThemeColor = {
	color: MINDMAP_COLOR_BLACK_DIRTY,
	contrast: MINDMAP_COLOR_WHITE,
	name: "Black"
};

export const MINDMAP_THEME_PALETTE_COLORS_ENERGY: MindmapPaletteColors = [
	{ color: "#E57373", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#BA68C8", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#9575CD", contrast: MINDMAP_COLOR_WHITE, name: "Violet" },
	{ color: "#818CF8", contrast: MINDMAP_COLOR_WHITE, name: "Indigo" },
	{ color: "#60A5FA", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#4DD0E1", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#2bc28c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Teal" },
	{ color: "#059669", contrast: MINDMAP_COLOR_WHITE, name: "Green" },
	{ color: "#AED581", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Green" },
	{ color: "#E2E05D", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Lime" },
	{ color: "#FCD34D", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#FFA500", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#A52A2A", contrast: MINDMAP_COLOR_WHITE, name: "Brown" }
];

/*export const MINDMAP_THEME_PALETTE_COLORS_GOOGLE: MindmapPaletteColors = [
	{ color: "#EF5350", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#EC407A", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#AB47BC", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#7E57C2", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#5C6BC0", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#42A5F5", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#26C6DA", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#26A69A", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#66BB6A", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#9CCC65", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#D4E157", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FFEE58", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FFCA28", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FFA726", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#FF7043", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#8D6E63", contrast: MINDMAP_COLOR_WHITE },
	{ color: "#BDBDBD", contrast: MINDMAP_COLOR_BLACK_DIRTY },
	{ color: "#78909C", contrast: MINDMAP_COLOR_WHITE }
];*/

export const MINDMAP_THEME_PALETTE_COLORS_PASTEL: MindmapPaletteColors = [
	{ color: "#ffadad", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#ffd6a5", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#fdffb6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#caffbf", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#9bf6ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#a0c4ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Indigo" },
	{ color: "#bdb2ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Violet" },
	{ color: "#ffc6ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Pink" }
];

export const THEME_PALETTE_COLORS_CANDY: MindmapPaletteColors = [
	{ color: "#ba88ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Purple" },
	{ color: "#ff78c7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Pink" },
	{ color: "#fee440", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#00bbf9", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#00f5d4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" }
];

export const MINDMAP_THEME_PALETTE_COLORS_RUST: MindmapPaletteColors = [
	{ color: "#053047", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#005f73", contrast: MINDMAP_COLOR_WHITE, name: "Teal" },
	{ color: "#0a9396", contrast: MINDMAP_COLOR_WHITE, name: "Cyan" },
	{ color: "#94d2bd", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Cyan" },
	{ color: "#e9d8a6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Yellow" },
	{ color: "#ee9b00", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#ca6702", contrast: MINDMAP_COLOR_WHITE, name: "Dark Orange" },
	{ color: "#bb3e03", contrast: MINDMAP_COLOR_WHITE, name: "Brown" },
	{ color: "#ae2012", contrast: MINDMAP_COLOR_WHITE, name: "Dark Red" },
	{ color: "#9b2226", contrast: MINDMAP_COLOR_WHITE, name: "Teal" }
];

export const MINDMAP_THEME_PALETTE_COLORS_BRIGHT: MindmapPaletteColors = [
	{ color: "#5aa9e6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#7fc8f8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Blue" },
	{ color: "#ffe45e", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#ff6392", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" }
];

export const MINDMAP_THEME_PALETTE_COLORS_FOREST: MindmapPaletteColors = [
	{ color: "#304f65", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#fe7f2d", contrast: MINDMAP_COLOR_WHITE, name: "Orange" },
	{ color: "#fcca46", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#a1c181", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Green" },
	{ color: "#619b8a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Dark Green" }
];

export const MINDMAP_THEME_PALETTE_COLORS_WAVES: MindmapPaletteColors = [
	{ color: "#023e8a", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#0077b6", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#0096c7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Blue" },
	{ color: "#00b4d8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#48cae4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Cyan" },
	{ color: "#90e0ef", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sky Blue" }
];

export const MINDMAP_THEME_PALETTE_COLORS_NATURE: MindmapPaletteColors = [
	{ color: "#ef476f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#ffd166", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#06d6a0", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#118ab2", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#073b4c", contrast: MINDMAP_COLOR_WHITE, name: "Teal" }
];

export const MINDMAP_THEME_PALETTE_COLORS_NOSTALGIA: MindmapPaletteColors = [
	{ color: "#264653", contrast: MINDMAP_COLOR_WHITE, name: "Teal" },
	{ color: "#2a9d8f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#e9c46a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#f4a261", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#e76f51", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" }
];

export const MINDMAP_THEME_PALETTE_COLORS_GLOW: MindmapPaletteColors = [
	{ color: "#355070", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#6d597a", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#b56576", contrast: MINDMAP_COLOR_WHITE, name: "Pink" },
	{ color: "#e56b6f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" },
	{ color: "#eaac8b", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" }
];

export const MINDMAP_THEME_PALETTE_COLORS_MURKY: MindmapPaletteColors = [
	{ color: "#99d98c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Green" },
	{ color: "#76c893", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#52b69a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Teal" },
	{ color: "#34a0a4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#168aad", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#1a759f", contrast: MINDMAP_COLOR_WHITE, name: "Dark Blue" },
	{ color: "#1e6091", contrast: MINDMAP_COLOR_WHITE, name: "Ocean Blue" }
];

export const MINDMAP_THEME_PALETTE_COLORS_FIRE: MindmapPaletteColors = [
	{ color: "#f7b267", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Orange" },
	{ color: "#f79d65", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#f4845f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Dark Orange" },
	{ color: "#f27059", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red Orange" },
	{ color: "#f25c54", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Red" }
];

export const MINDMAP_THEME_PALETTE_COLORS_VACATION: MindmapPaletteColors = [
	{ color: "#2364aa", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#3da5d9", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Light Blue" },
	{ color: "#73bfb8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#fec601", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#ea7317", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" }
];

export const MINDMAP_THEME_PALETTE_COLORS_EMBER: MindmapPaletteColors = [
	{ color: "#5e1614", contrast: MINDMAP_COLOR_WHITE, name: "Maroon" },
	{ color: "#a32218", contrast: MINDMAP_COLOR_WHITE, name: "Red" },
	{ color: "#e23e1c", contrast: MINDMAP_COLOR_WHITE, name: "Ember" },
	{ color: "#f47b3c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Flame" },
	{ color: "#ffb86b", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Glow" },
	{ color: "#ffe1a8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Spark" }
];

export const MINDMAP_THEME_PALETTE_COLORS_NEON: MindmapPaletteColors = [
	{ color: "#ff2bd6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Magenta" },
	{ color: "#b026ff", contrast: MINDMAP_COLOR_WHITE, name: "Violet" },
	{ color: "#5b5bff", contrast: MINDMAP_COLOR_WHITE, name: "Indigo" },
	{ color: "#00d4ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" },
	{ color: "#39ff88", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Mint" },
	{ color: "#fff176", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Lemon" }
];

export const MINDMAP_THEME_PALETTE_COLORS_ARCTIC: MindmapPaletteColors = [
	{ color: "#0b3a5b", contrast: MINDMAP_COLOR_WHITE, name: "Deep Sea" },
	{ color: "#1f6fb2", contrast: MINDMAP_COLOR_WHITE, name: "Ocean" },
	{ color: "#3aa0e3", contrast: MINDMAP_COLOR_WHITE, name: "Sky" },
	{ color: "#7cc6f5", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Ice" },
	{ color: "#cfeaff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Frost" },
	{ color: "#94a8b8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Slate" }
];

export const MINDMAP_THEME_PALETTE_COLORS_MEADOW: MindmapPaletteColors = [
	{ color: "#2f6d3a", contrast: MINDMAP_COLOR_WHITE, name: "Pine" },
	{ color: "#5fa84b", contrast: MINDMAP_COLOR_WHITE, name: "Leaf" },
	{ color: "#a9d65a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Lime" },
	{ color: "#f1e25c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sun" },
	{ color: "#f5b942", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Honey" },
	{ color: "#e98a5c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Apricot" }
];

export const MINDMAP_THEME_PALETTE_COLORS_TERRA: MindmapPaletteColors = [
	{ color: "#3b2a1c", contrast: MINDMAP_COLOR_WHITE, name: "Earth" },
	{ color: "#7a4f2a", contrast: MINDMAP_COLOR_WHITE, name: "Bark" },
	{ color: "#b07b3f", contrast: MINDMAP_COLOR_WHITE, name: "Clay" },
	{ color: "#c9a86a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sand" },
	{ color: "#7c8a4a", contrast: MINDMAP_COLOR_WHITE, name: "Olive" },
	{ color: "#4d6a4a", contrast: MINDMAP_COLOR_WHITE, name: "Moss" }
];

export const MINDMAP_THEME_PALETTE_COLORS_MIDNIGHT: MindmapPaletteColors = [
	{ color: "#1f2659", contrast: MINDMAP_COLOR_WHITE, name: "Navy" },
	{ color: "#3b3f8a", contrast: MINDMAP_COLOR_WHITE, name: "Indigo" },
	{ color: "#6b3fa0", contrast: MINDMAP_COLOR_WHITE, name: "Plum" },
	{ color: "#a778d0", contrast: MINDMAP_COLOR_WHITE, name: "Lavender" },
	{ color: "#c9c9d6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Silver" },
	{ color: "#f0e6ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Moon" }
];

export const MINDMAP_THEME_PALETTE_COLORS_ELECTRIC: MindmapPaletteColors = [
	{ color: "#FF3600", contrast: MINDMAP_COLOR_WHITE, name: "Volt Red" },
	{ color: "#0633F8", contrast: MINDMAP_COLOR_WHITE, name: "Electric Blue" },
	{ color: "#E4E9FF", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Static" }
];

export const MINDMAP_THEME_PALETTE_COLORS_GLACIER: MindmapPaletteColors = [
	{ color: "#e0fbfc", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Ice" },
	{ color: "#c2dfe3", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Frost" },
	{ color: "#9db4c0", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Mist" },
	{ color: "#5c6b73", contrast: MINDMAP_COLOR_WHITE, name: "Slate" },
	{ color: "#253237", contrast: MINDMAP_COLOR_WHITE, name: "Crevasse" }
];

export const MINDMAP_THEME_PALETTE_COLORS_DOCKSIDE: MindmapPaletteColors = [
	{ color: "#f79256", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Buoy" },
	{ color: "#fbd1a2", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sand" },
	{ color: "#7dcfb6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Seafoam" },
	{ color: "#00b2ca", contrast: MINDMAP_COLOR_WHITE, name: "Harbor" },
	{ color: "#1d4e89", contrast: MINDMAP_COLOR_WHITE, name: "Navy" }
];

export const MINDMAP_THEME_PALETTE_COLORS_BEACON: MindmapPaletteColors = [
	{ color: "#0b3954", contrast: MINDMAP_COLOR_WHITE, name: "Midnight" },
	{ color: "#087e8b", contrast: MINDMAP_COLOR_WHITE, name: "Signal" },
	{ color: "#bfd7ea", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Haze" },
	{ color: "#ff5a5f", contrast: MINDMAP_COLOR_WHITE, name: "Flare" },
	{ color: "#c81d25", contrast: MINDMAP_COLOR_WHITE, name: "Beacon" }
];

export const MINDMAP_THEME_PALETTE_COLORS_ATLAS: MindmapPaletteColors = [
	{ color: "#2b2d42", contrast: MINDMAP_COLOR_WHITE, name: "Ink" },
	{ color: "#8d99ae", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Compass" },
	{ color: "#edf2f4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Parchment" },
	{ color: "#ef233c", contrast: MINDMAP_COLOR_WHITE, name: "Route" },
	{ color: "#d80032", contrast: MINDMAP_COLOR_WHITE, name: "Marker" }
];

export const MINDMAP_THEME_PALETTE_COLORS_CYBER: MindmapPaletteColors = [
	{ color: "#ff206e", contrast: MINDMAP_COLOR_WHITE, name: "Hot Pink" },
	{ color: "#fbff12", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Acid" },
	{ color: "#41ead4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Aqua" }
];

export const MINDMAP_THEME_PALETTE_COLORS_ASPHALT: MindmapPaletteColors = [
	{ color: "#d6d6d6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Concrete" },
	{ color: "#ffee32", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Stripe" },
	{ color: "#ffd100", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Signal" },
	{ color: "#202020", contrast: MINDMAP_COLOR_WHITE, name: "Road" },
	{ color: "#333533", contrast: MINDMAP_COLOR_WHITE, name: "Asphalt" }
];

export const MINDMAP_THEME_PALETTE_COLORS_PARADE: MindmapPaletteColors = [
	{ color: "#006ba6", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#0496ff", contrast: MINDMAP_COLOR_WHITE, name: "Sky" },
	{ color: "#ffbc42", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Gold" },
	{ color: "#d81159", contrast: MINDMAP_COLOR_WHITE, name: "Pink" },
	{ color: "#8f2d56", contrast: MINDMAP_COLOR_WHITE, name: "Berry" }
];

export const MINDMAP_THEME_PALETTE_COLORS_ROSEWATER: MindmapPaletteColors = [
	{ color: "#880d1e", contrast: MINDMAP_COLOR_WHITE, name: "Wine" },
	{ color: "#dd2d4a", contrast: MINDMAP_COLOR_WHITE, name: "Rose" },
	{ color: "#f26a8d", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blush" },
	{ color: "#f49cbb", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Petal" },
	{ color: "#cbeef3", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Mist" }
];

export const MINDMAP_THEME_PALETTE_COLORS_DAYGLOW: MindmapPaletteColors = [
	{ color: "#f9c80e", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Gold" },
	{ color: "#f86624", contrast: MINDMAP_COLOR_WHITE, name: "Orange" },
	{ color: "#ea3546", contrast: MINDMAP_COLOR_WHITE, name: "Red" },
	{ color: "#662e9b", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#43bccd", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" }
];

export const MINDMAP_THEME_PALETTE_COLORS_MARSHMALLOW: MindmapPaletteColors = [
	{ color: "#90f1ef", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Mint" },
	{ color: "#ffd6e0", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Pink" },
	{ color: "#ffef9f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Vanilla" },
	{ color: "#c1fba4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Pistachio" },
	{ color: "#7bf1a8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" }
];

export const MINDMAP_THEME_PALETTE_COLORS_CAMPFIRE: MindmapPaletteColors = [
	{ color: "#177e89", contrast: MINDMAP_COLOR_WHITE, name: "Teal" },
	{ color: "#084c61", contrast: MINDMAP_COLOR_WHITE, name: "Night" },
	{ color: "#db3a34", contrast: MINDMAP_COLOR_WHITE, name: "Ember" },
	{ color: "#ffc857", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Flame" },
	{ color: "#323031", contrast: MINDMAP_COLOR_WHITE, name: "Charcoal" }
];

export const MINDMAP_THEME_PALETTE_COLORS_CERAMIC: MindmapPaletteColors = [
	{ color: "#fe938c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Coral" },
	{ color: "#e6b89c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Clay" },
	{ color: "#ead2ac", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sand" },
	{ color: "#9cafb7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Glaze" },
	{ color: "#4281a4", contrast: MINDMAP_COLOR_WHITE, name: "Blue" }
];

export const MINDMAP_THEME_PALETTE_COLORS_CHROME: MindmapPaletteColors = [
	{ color: "#ff6700", contrast: MINDMAP_COLOR_WHITE, name: "Orange" },
	{ color: "#ebebeb", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Chrome" },
	{ color: "#c0c0c0", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Silver" },
	{ color: "#3a6ea5", contrast: MINDMAP_COLOR_WHITE, name: "Steel" },
	{ color: "#004e98", contrast: MINDMAP_COLOR_WHITE, name: "Blue" }
];

export const MINDMAP_THEME_PALETTE_COLORS_ARCADE: MindmapPaletteColors = [
	{ color: "#540d6e", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#ee4266", contrast: MINDMAP_COLOR_WHITE, name: "Pink" },
	{ color: "#ffd23f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#3bceac", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Mint" },
	{ color: "#0ead69", contrast: MINDMAP_COLOR_WHITE, name: "Green" }
];

export const MINDMAP_THEME_PALETTE_COLORS_WAVELENGTH: MindmapPaletteColors = [
	{ color: "#b7094c", contrast: MINDMAP_COLOR_WHITE, name: "Red" },
	{ color: "#a01a58", contrast: MINDMAP_COLOR_WHITE, name: "Raspberry" },
	{ color: "#892b64", contrast: MINDMAP_COLOR_WHITE, name: "Berry" },
	{ color: "#723c70", contrast: MINDMAP_COLOR_WHITE, name: "Plum" },
	{ color: "#5c4d7d", contrast: MINDMAP_COLOR_WHITE, name: "Violet" },
	{ color: "#455e89", contrast: MINDMAP_COLOR_WHITE, name: "Indigo" },
	{ color: "#2e6f95", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#1780a1", contrast: MINDMAP_COLOR_WHITE, name: "Cyan" },
	{ color: "#0091ad", contrast: MINDMAP_COLOR_WHITE, name: "Aqua" }
];

export const MINDMAP_THEME_PALETTE_COLORS_HARVEST: MindmapPaletteColors = [
	{ color: "#8cb369", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sage" },
	{ color: "#f4e285", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Wheat" },
	{ color: "#f4a259", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Pumpkin" },
	{ color: "#5b8e7d", contrast: MINDMAP_COLOR_WHITE, name: "Moss" },
	{ color: "#bc4b51", contrast: MINDMAP_COLOR_WHITE, name: "Cranberry" }
];

export const MINDMAP_THEME_PALETTE_COLORS_CONFETTI: MindmapPaletteColors = [
	{ color: "#ffbc42", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Gold" },
	{ color: "#d81159", contrast: MINDMAP_COLOR_WHITE, name: "Pink" },
	{ color: "#8f2d56", contrast: MINDMAP_COLOR_WHITE, name: "Berry" },
	{ color: "#218380", contrast: MINDMAP_COLOR_WHITE, name: "Teal" },
	{ color: "#73d2de", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Cyan" }
];

export const MINDMAP_THEME_PALETTE_COLORS_TIDES: MindmapPaletteColors = [
	{ color: "#16697a", contrast: MINDMAP_COLOR_WHITE, name: "Deep Tide" },
	{ color: "#489fb5", contrast: MINDMAP_COLOR_WHITE, name: "Wave" },
	{ color: "#82c0cc", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Foam" },
	{ color: "#ede7e3", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Shell" },
	{ color: "#ffa62b", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sun" }
];

export const MINDMAP_THEME_PALETTE_COLORS_ULTRAVIOLET: MindmapPaletteColors = [
	{ color: "#2d00f7", contrast: MINDMAP_COLOR_WHITE, name: "Violet 1" },
	{ color: "#6a00f4", contrast: MINDMAP_COLOR_WHITE, name: "Violet 2" },
	{ color: "#8900f2", contrast: MINDMAP_COLOR_WHITE, name: "Violet 3" },
	{ color: "#a100f2", contrast: MINDMAP_COLOR_WHITE, name: "Violet 4" },
	{ color: "#b100e8", contrast: MINDMAP_COLOR_WHITE, name: "Violet 5" },
	{ color: "#bc00dd", contrast: MINDMAP_COLOR_WHITE, name: "Violet 6" },
	{ color: "#d100d1", contrast: MINDMAP_COLOR_WHITE, name: "Magenta 1" },
	{ color: "#db00b6", contrast: MINDMAP_COLOR_WHITE, name: "Magenta 2" },
	{ color: "#e500a4", contrast: MINDMAP_COLOR_WHITE, name: "Magenta 3" },
	{ color: "#f20089", contrast: MINDMAP_COLOR_WHITE, name: "Magenta 4" }
];

export const MINDMAP_THEME_PALETTE_COLORS_BLOOM: MindmapPaletteColors = [
	{ color: "#ff0a54", contrast: MINDMAP_COLOR_WHITE, name: "Bloom 1" },
	{ color: "#ff477e", contrast: MINDMAP_COLOR_WHITE, name: "Bloom 2" },
	{ color: "#ff5c8a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 3" },
	{ color: "#ff7096", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 4" },
	{ color: "#ff85a1", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 5" },
	{ color: "#ff99ac", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 6" },
	{ color: "#fbb1bd", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 7" },
	{ color: "#f9bec7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 8" },
	{ color: "#f7cad0", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 9" },
	{ color: "#fae0e4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Bloom 10" }
];

export const MINDMAP_THEME_PALETTE_COLORS_PAPRIKA: MindmapPaletteColors = [
	{ color: "#220901", contrast: MINDMAP_COLOR_WHITE, name: "Char" },
	{ color: "#621708", contrast: MINDMAP_COLOR_WHITE, name: "Chili" },
	{ color: "#941b0c", contrast: MINDMAP_COLOR_WHITE, name: "Paprika" },
	{ color: "#bc3908", contrast: MINDMAP_COLOR_WHITE, name: "Rust" },
	{ color: "#f6aa1c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Spice" }
];

export const MINDMAP_THEME_PALETTE_COLORS_GEMSTONE: MindmapPaletteColors = [
	{ color: "#3d348b", contrast: MINDMAP_COLOR_WHITE, name: "Amethyst" },
	{ color: "#7678ed", contrast: MINDMAP_COLOR_WHITE, name: "Sapphire" },
	{ color: "#f7b801", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Topaz" },
	{ color: "#f18701", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Amber" },
	{ color: "#f35b04", contrast: MINDMAP_COLOR_WHITE, name: "Garnet" }
];

export const MINDMAP_THEME_PALETTE_COLORS_CROWN: MindmapPaletteColors = [
	{ color: "#00296b", contrast: MINDMAP_COLOR_WHITE, name: "Royal" },
	{ color: "#003f88", contrast: MINDMAP_COLOR_WHITE, name: "Cobalt" },
	{ color: "#00509d", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#fdc500", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Gold" },
	{ color: "#ffd500", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Crown" }
];

export const MINDMAP_THEME_PALETTE_COLORS_OASIS: MindmapPaletteColors = [
	{ color: "#001524", contrast: MINDMAP_COLOR_WHITE, name: "Night" },
	{ color: "#15616d", contrast: MINDMAP_COLOR_WHITE, name: "Oasis" },
	{ color: "#ffecd1", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sand" },
	{ color: "#ff7d00", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sun" },
	{ color: "#78290f", contrast: MINDMAP_COLOR_WHITE, name: "Clay" }
];

export const MINDMAP_THEME_PALETTE_COLORS_SPROUT: MindmapPaletteColors = [
	{ color: "#1a535c", contrast: MINDMAP_COLOR_WHITE, name: "Stem" },
	{ color: "#4ecdc4", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sprout" },
	{ color: "#f7fff7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Petal" },
	{ color: "#ff6b6b", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Coral" },
	{ color: "#ffe66d", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sun" }
];

export const MINDMAP_THEME_PALETTE_COLORS_PLAYFUL: MindmapPaletteColors = [
	{ color: "#ff595e", contrast: MINDMAP_COLOR_WHITE, name: "Red" },
	{ color: "#ffca3a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#8ac926", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#1982c4", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#6a4c93", contrast: MINDMAP_COLOR_WHITE, name: "Purple" }
];

export const MINDMAP_THEME_PALETTE_COLORS_SUNDOWN: MindmapPaletteColors = [
	{ color: "#390099", contrast: MINDMAP_COLOR_WHITE, name: "Dusk" },
	{ color: "#9e0059", contrast: MINDMAP_COLOR_WHITE, name: "Plum" },
	{ color: "#ff0054", contrast: MINDMAP_COLOR_WHITE, name: "Pink" },
	{ color: "#ff5400", contrast: MINDMAP_COLOR_WHITE, name: "Orange" },
	{ color: "#ffbd00", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sun" }
];

export const MINDMAP_THEME_PALETTE_COLORS_MINT: MindmapPaletteColors = [
	{ color: "#ff9f1c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#ffbf69", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Peach" },
	{ color: "#cbf3f0", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Ice" },
	{ color: "#2ec4b6", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Mint" }
];

export const MINDMAP_THEME_PALETTE_COLORS_SEASIDE: MindmapPaletteColors = [
	{ color: "#0081a7", contrast: MINDMAP_COLOR_WHITE, name: "Ocean" },
	{ color: "#00afb9", contrast: MINDMAP_COLOR_WHITE, name: "Aqua" },
	{ color: "#fdfcdc", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Shell" },
	{ color: "#fed9b7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sand" },
	{ color: "#f07167", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Coral" }
];

export const MINDMAP_THEME_PALETTE_COLORS_HEIRLOOM: MindmapPaletteColors = [
	{ color: "#f4f1de", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Ivory" },
	{ color: "#e07a5f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Terracotta" },
	{ color: "#3d405b", contrast: MINDMAP_COLOR_WHITE, name: "Ink" },
	{ color: "#81b29a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sage" },
	{ color: "#f2cc8f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Wheat" }
];

export const MINDMAP_THEME_PALETTE_COLORS_SUPERNOVA: MindmapPaletteColors = [
	{ color: "#ffbe0b", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#fb5607", contrast: MINDMAP_COLOR_WHITE, name: "Orange" },
	{ color: "#ff006e", contrast: MINDMAP_COLOR_WHITE, name: "Pink" },
	{ color: "#8338ec", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#3a86ff", contrast: MINDMAP_COLOR_WHITE, name: "Blue" }
];

export const MINDMAP_THEME_PALETTE_COLORS_TAILORED: MindmapPaletteColors = [
	{ color: "#14213d", contrast: MINDMAP_COLOR_WHITE, name: "Navy" },
	{ color: "#fca311", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Gold" },
	{ color: "#e5e5e5", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Silver" }
];

export const MINDMAP_THEME_PALETTE_COLORS_COLORWHEEL: MindmapPaletteColors = [
	{ color: "#ff3e41", contrast: MINDMAP_COLOR_WHITE, name: "Red" },
	{ color: "#ff5f42", contrast: MINDMAP_COLOR_WHITE, name: "Vermilion" },
	{ color: "#ff8a43", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" },
	{ color: "#ffb85c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Amber" },
	{ color: "#ffeb7f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#b8e86e", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Lime" },
	{ color: "#4fdc8a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Green" },
	{ color: "#00c9a7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Teal" },
	{ color: "#00aeca", contrast: MINDMAP_COLOR_WHITE, name: "Cyan" },
	{ color: "#007ea7", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#4b6fc7", contrast: MINDMAP_COLOR_WHITE, name: "Indigo" },
	{ color: "#8a5fd3", contrast: MINDMAP_COLOR_WHITE, name: "Violet" },
	{ color: "#d957b8", contrast: MINDMAP_COLOR_WHITE, name: "Magenta" }
];

export const MINDMAP_THEME_PALETTE_COLORS_MIXTAPE: MindmapPaletteColors = [
	{ color: "#ff3e41", contrast: MINDMAP_COLOR_WHITE, name: "Red" },
	{ color: "#ffeb7f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#007ea7", contrast: MINDMAP_COLOR_WHITE, name: "Blue" },
	{ color: "#d957b8", contrast: MINDMAP_COLOR_WHITE, name: "Magenta" }
];

export const MINDMAP_THEME_PALETTE_COLORS_TROPICAL: MindmapPaletteColors = [
	{ color: "#00c9a7", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Lagoon" },
	{ color: "#00d7c8", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Aqua" },
	{ color: "#00aeca", contrast: MINDMAP_COLOR_WHITE, name: "Cyan" },
	{ color: "#007ea7", contrast: MINDMAP_COLOR_WHITE, name: "Ocean" },
	{ color: "#4fdc8a", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Palm" },
	{ color: "#b8e86e", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Lime" },
	{ color: "#ffb85c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Mango" },
	{ color: "#ff5f42", contrast: MINDMAP_COLOR_WHITE, name: "Coral" }
];

export const MINDMAP_THEME_PALETTE_COLORS_DUSK: MindmapPaletteColors = [
	{ color: "#ff3e41", contrast: MINDMAP_COLOR_WHITE, name: "Sunset" },
	{ color: "#ff8a43", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Tangerine" },
	{ color: "#ffb85c", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Amber" },
	{ color: "#ffeb7f", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Glow" },
	{ color: "#8a5fd3", contrast: MINDMAP_COLOR_WHITE, name: "Twilight" },
	{ color: "#4b3f72", contrast: MINDMAP_COLOR_WHITE, name: "Dusk" }
];

export const MINDMAP_THEME_PALETTE_COLORS_TRON: MindmapPaletteColors = [
	{ color: "#00e5ff", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Neon" },
	{ color: "#007ea7", contrast: MINDMAP_COLOR_WHITE, name: "Grid" },
	{ color: "#ff8a43", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Flare" }
];

export const MINDMAP_THEME_PALETTE_COLORS_SYNTHWAVE: MindmapPaletteColors = [
	{ color: "#ff3e9e", contrast: MINDMAP_COLOR_WHITE, name: "Hotpink" },
	{ color: "#ff8a43", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Sunset" },
	{ color: "#8a5fd3", contrast: MINDMAP_COLOR_WHITE, name: "Violet" },
	{ color: "#4b6fc7", contrast: MINDMAP_COLOR_WHITE, name: "Indigo" },
	{ color: "#00aeca", contrast: MINDMAP_COLOR_WHITE, name: "Cyan" },
	{ color: "#111122", contrast: MINDMAP_COLOR_WHITE, name: "Night" }
];

export const MINDMAP_THEME_PALETTE_COLORS_FRIENDS: MindmapPaletteColors = [
	{ color: "#E31B23", contrast: MINDMAP_COLOR_WHITE, name: "Red" },
	{ color: "#00AEEF", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Blue" },
	{ color: "#FFD100", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Yellow" },
	{ color: "#8E5EA2", contrast: MINDMAP_COLOR_WHITE, name: "Purple" },
	{ color: "#D8BFA3", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Taupe" },
	{ color: "#6F4E37", contrast: MINDMAP_COLOR_WHITE, name: "Coffee" },
	{ color: "#1F5C3A", contrast: MINDMAP_COLOR_WHITE, name: "Green" },
	{ color: "#F28C28", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "Orange" }
];
